// One voice note or video note at a time across the chat.

export const MEDIA_PLAY_EVENT = 'bazzef-media-play';

export const claimMediaPlayback = (ownerId) => {
  if (typeof window === 'undefined' || ownerId == null) return;
  window.dispatchEvent(new CustomEvent(MEDIA_PLAY_EVENT, { detail: { id: String(ownerId) } }));
};

export const onMediaPlaybackClaim = (ownerId, onOther) => {
  if (typeof window === 'undefined') return () => {};
  const self = String(ownerId);
  const handler = (event) => {
    const activeId = event?.detail?.id;
    if (!activeId || activeId === self) return;
    onOther(activeId);
  };
  window.addEventListener(MEDIA_PLAY_EVENT, handler);
  return () => window.removeEventListener(MEDIA_PLAY_EVENT, handler);
};
